import { config } from "../../config/corrector";
import { MatchesEntity, Rule } from "./types";
import { SegmentRepository } from "../SegmentRepository";

export class MatchesRepository extends SegmentRepository<MatchesEntity>{ 
    constructor() {
        super()
        this.enabled = true
    }
}

export const getMaxSuggestions = (rule : Rule) => {
    if (["mispelling", "locale-violation"].includes(rule.issueType)){
        return config.maxSpellcheckSuggestions
    }

    if (document?.getElementById('editor-area')?.offsetWidth || 0 < 400) {
        return config.maxSuggestionsMobile
    }

    return config.maxSuggestions
}